import * as React from "react";
const CarrierBee = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width={537}
        height={367}
        viewBox="0 0 537 367"
        fill="none"
        {...props}
    >
        <path
            d="M528.788 366.967H180.018C174.939 366.967 171.146 361.644 171.925 355.765C182.084 278.065 259.939 217.604 354.42 217.604C448.902 217.604 526.722 278.065 536.882 355.765C537.661 361.644 533.868 366.967 528.788 366.967Z"
            fill="url(#paint0_linear_5841_7949)"
        />
        <mask
            id="mask0_5841_7949"
            style={{
                maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={171}
            y={217}
            width={367}
            height={150}
        >
            <path
                d="M528.803 366.966H179.939C174.858 366.966 171.064 361.643 171.843 355.763C182.005 278.063 259.88 217.603 354.388 217.603C448.895 217.603 526.737 278.063 536.899 355.763C537.678 361.643 533.884 366.966 528.803 366.966Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask0_5841_7949)">
            <path
                d="M396.102 206.805C396.102 206.805 394.917 224.164 385.466 229.13C376.015 234.095 362.94 236.876 363.008 253.64C363.075 270.403 366.124 278.467 369.173 297.336C372.221 316.205 357.689 324.348 359.993 335.074C363.719 352.513 385.906 344.648 395.526 340.715C402.403 337.894 410.566 333.207 416.562 327.447C422.964 321.329 426.656 312.312 433.092 306.274C440.883 299.044 451.113 293.681 461.004 292.291C476.315 290.146 514.592 279.381 517.641 269.489C520.689 259.598 471.708 212.724 471.708 212.724L396.068 206.765L396.102 206.805Z"
                fill="url(#paint1_linear_5841_7949)"
            />
            <path
                d="M150.077 356.568C166.303 349.338 181.173 342.625 198.652 342.108C205.054 341.91 225.107 341.512 229.646 335.037C229.646 335.037 244.178 314.341 256.44 308.978C268.703 303.616 279.373 301.788 285.131 302.702C290.958 303.616 298.579 302.265 301.492 310.011C305.422 320.419 290.145 332.614 297.326 342.069C297.326 342.069 306.946 354.741 301.594 371.822C296.242 388.903 263.926 407.732 263.926 407.732L163.186 382.587L150.077 356.568Z"
                fill="url(#paint2_linear_5841_7949)"
            />
        </g>
        <path
            d="M139.961 191.237C131.73 201.278 119.535 208.81 113.303 220.536C107.07 232.263 112.761 248.15 126.31 251.727C144.026 256.404 180.914 241.41 180.914 241.41L139.961 191.237Z"
            fill="url(#paint3_linear_5841_7949)"
        />
        <path
            d="M391.362 120.566C407.114 127.066 422.425 130.746 439.158 132.946C454.029 134.907 450.709 149.384 441.97 157.225C427.031 170.671 412.296 186.215 396.308 198.182C387.569 189.826 392.006 166.957 391.735 155.609C391.464 143.916 391.295 132.259 391.362 120.566Z"
            fill="url(#paint4_linear_5841_7949)"
        />
        <path
            d="M381.487 86.421C346.293 43.9164 281.086 21.0478 227.261 33.7029C186.443 43.2974 153.586 72.184 140.985 113.107C124.149 167.647 141.154 229.375 192.71 256.405C236.136 279.17 292.671 278.964 336.842 258.4C362.62 246.432 385.552 225.661 397.137 199.079C416.072 155.508 406.147 116.133 381.521 86.3866L381.487 86.421Z"
            fill="url(#paint5_linear_5841_7949)"
        />
        <mask
            id="mask1_5841_7949"
            style={{
                maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={134}
            y={30}
            width={273}
            height={244}
        >
            <path
                d="M381.44 86.4273C346.246 43.9227 281.039 21.0542 227.214 33.7093C186.396 43.3038 153.539 72.1904 140.938 113.113C124.102 167.654 141.107 229.382 192.663 256.411C236.089 279.177 292.624 278.97 336.795 258.406C362.573 246.439 385.505 225.668 397.09 199.085C416.025 155.514 406.1 116.139 381.474 86.393L381.44 86.4273Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask1_5841_7949)">
            <path
                d="M383.747 86.4174C404.071 120.703 402.31 170.154 387.981 206.434C373.551 243.059 345.03 274.112 317.219 300.832C306.109 311.492 322.91 328.515 333.987 317.854C366.404 286.732 398.889 249.799 413.319 206.125C426.902 164.996 426.699 112.175 404.241 74.2438C396.382 60.9697 375.888 73.0746 383.781 86.383L383.747 86.4174Z"
                fill="url(#paint6_linear_5841_7949)"
            />
            <path
                d="M334.006 42.5698C343.389 49.31 351.756 57.5633 359.106 66.8139C366.389 76.0989 372.622 86.45 377.262 97.5919C386.611 119.876 389.491 145.152 385.663 169.189C383.8 181.157 380.717 192.677 376.382 203.957C371.978 215.167 366.084 225.862 358.734 235.457C351.451 245.086 342.542 253.408 332.685 259.942C322.794 266.475 311.988 271.221 300.843 274.007L299.624 270.808C309.413 265.272 318.492 259.047 326.418 251.654C328.45 249.9 330.28 247.871 332.143 245.945C334.073 244.088 335.767 241.991 337.461 239.927C339.222 237.933 340.747 235.697 342.271 233.531C343.863 231.399 345.286 229.129 346.674 226.894C357.751 208.737 364.052 187.691 367.033 166.404C369.878 145.358 368.015 123.899 361.714 103.438C358.564 93.1902 354.432 83.1486 349.317 73.451C344.236 63.719 338.138 54.3996 331.668 45.0114L334.04 42.5698H334.006Z"
                fill="url(#paint7_linear_5841_7949)"
            />
        </g>
        <path
            d="M274.142 51.8632C274.142 51.8632 279.663 18.1278 299.987 11.25"
            stroke="url(#paint8_linear_5841_7949)"
            strokeWidth={2.685}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M185.507 19.6685C185.507 19.6685 205.178 29.4125 210.743 54.0229"
            stroke="url(#paint9_linear_5841_7949)"
            strokeWidth={2.685}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M307.508 15.3374C311.68 15.3374 315.062 11.904 315.062 7.66871C315.062 3.4334 311.68 0 307.508 0C303.336 0 299.954 3.4334 299.954 7.66871C299.954 11.904 303.336 15.3374 307.508 15.3374Z"
            fill="url(#paint10_linear_5841_7949)"
        />
        <path
            d="M180.915 23.1397C185.087 23.1397 188.469 19.7063 188.469 15.471C188.469 11.2356 185.087 7.80225 180.915 7.80225C176.743 7.80225 173.361 11.2356 173.361 15.471C173.361 19.7063 176.743 23.1397 180.915 23.1397Z"
            fill="url(#paint11_linear_5841_7949)"
        />
        <path
            d="M106.712 82.6058C110.528 82.6058 113.622 79.465 113.622 75.5905C113.622 71.7161 110.528 68.5752 106.712 68.5752C102.896 68.5752 99.8018 71.7161 99.8018 75.5905C99.8018 79.465 102.896 82.6058 106.712 82.6058Z"
            fill="url(#paint12_linear_5841_7949)"
        />
        <path
            d="M94.7041 54.8221V54.7877C94.7041 53.6291 93.779 52.6899 92.6378 52.6899H88.7085C87.5673 52.6899 86.6422 53.6291 86.6422 54.7877V54.8221C86.6422 55.9806 87.5673 56.9198 88.7085 56.9198H92.6378C93.779 56.9198 94.7041 55.9806 94.7041 54.8221Z"
            fill="url(#paint13_linear_5841_7949)"
        />
        <path
            d="M80.0479 54.8221V54.7877C80.0479 53.6291 79.1227 52.6899 77.9816 52.6899H74.0522C72.911 52.6899 71.9859 53.6291 71.9859 54.7877V54.8221C71.9859 55.9806 72.911 56.9198 74.0522 56.9198H77.9816C79.1227 56.9198 80.0479 55.9806 80.0479 54.8221Z"
            fill="url(#paint14_linear_5841_7949)"
        />
        <path
            d="M83.3502 43.2666H83.3163C82.1751 43.2666 81.25 44.2058 81.25 45.3643V49.3534C81.25 50.512 82.1751 51.4511 83.3163 51.4511H83.3502C84.4913 51.4511 85.4165 50.512 85.4165 49.3534V45.3643C85.4165 44.2058 84.4913 43.2666 83.3502 43.2666Z"
            fill="url(#paint15_linear_5841_7949)"
        />
        <path
            d="M83.3502 58.1157H83.3163C82.1751 58.1157 81.25 59.0549 81.25 60.2134V64.2025C81.25 65.3611 82.1751 66.3003 83.3163 66.3003H83.3502C84.4913 66.3003 85.4165 65.3611 85.4165 64.2025V60.2134C85.4165 59.0549 84.4913 58.1157 83.3502 58.1157Z"
            fill="url(#paint16_linear_5841_7949)"
        />
        <path
            d="M103.709 146.332H92.1582V233.473H103.709V146.332Z"
            fill="url(#paint17_linear_5841_7949)"
        />
        <path
            d="M38.8185 146.332H27.2676V233.473H38.8185V146.332Z"
            fill="url(#paint18_linear_5841_7949)"
        />
        <path
            d="M107.717 131.468H23.2703C18.425 131.468 14.4971 135.455 14.4971 140.374C14.4971 145.294 18.425 149.281 23.2703 149.281H107.717C112.563 149.281 116.491 145.294 116.491 140.374C116.491 135.455 112.563 131.468 107.717 131.468Z"
            fill="url(#paint19_linear_5841_7949)"
        />
        <path
            d="M116.559 228.312H14.3963C6.44544 228.312 0 234.856 0 242.928V330.791C0 338.863 6.44544 345.406 14.3963 345.406H116.559C124.51 345.406 130.955 338.863 130.955 330.791V242.928C130.955 234.856 124.51 228.312 116.559 228.312Z"
            fill="url(#paint20_linear_5841_7949)"
        />
        <path
            d="M106.469 361.637C112.531 361.637 117.444 356.649 117.444 350.495C117.444 344.341 112.531 339.353 106.469 339.353C100.408 339.353 95.4941 344.341 95.4941 350.495C95.4941 356.649 100.408 361.637 106.469 361.637Z"
            fill="url(#paint21_linear_5841_7949)"
        />
        <path
            d="M24.4702 361.637C30.5315 361.637 35.4452 356.649 35.4452 350.495C35.4452 344.341 30.5315 339.353 24.4702 339.353C18.4088 339.353 13.4951 344.341 13.4951 350.495C13.4951 356.649 18.4088 361.637 24.4702 361.637Z"
            fill="url(#paint22_linear_5841_7949)"
        />
        <path
            opacity={0.35}
            d="M42.001 312.15L42.001 261.598C42.001 256.679 38.073 252.691 33.2277 252.691C28.3824 252.691 24.4544 256.679 24.4544 261.598L24.4544 312.15C24.4544 317.069 28.3824 321.056 33.2277 321.056C38.073 321.056 42.001 317.069 42.001 312.15Z"
            fill="url(#paint23_linear_5841_7949)"
        />
        <path
            opacity={0.35}
            d="M74.249 312.11V261.558C74.249 256.639 70.3211 252.651 65.4757 252.651C60.6304 252.651 56.7025 256.639 56.7025 261.558V312.11C56.7025 317.029 60.6304 321.016 65.4757 321.016C70.3211 321.016 74.249 317.029 74.249 312.11Z"
            fill="url(#paint24_linear_5841_7949)"
        />
        <path
            opacity={0.35}
            d="M106.479 312.11V261.558C106.479 256.639 102.551 252.651 97.7052 252.651C92.8599 252.651 88.932 256.639 88.932 261.558V312.11C88.932 317.029 92.8599 321.016 97.7052 321.016C102.551 321.016 106.479 317.029 106.479 312.11Z"
            fill="url(#paint25_linear_5841_7949)"
        />
        <path
            opacity={0.36}
            d="M295.313 192.439C313.31 192.439 327.899 177.628 327.899 159.357C327.899 141.087 313.31 126.275 295.313 126.275C277.316 126.275 262.727 141.087 262.727 159.357C262.727 177.628 277.316 192.439 295.313 192.439Z"
            fill="url(#paint26_radial_5841_7949)"
        />
        <path
            opacity={0.36}
            d="M180.908 192.439C198.905 192.439 213.494 177.628 213.494 159.357C213.494 141.087 198.905 126.275 180.908 126.275C162.911 126.275 148.321 141.087 148.321 159.357C148.321 177.628 162.911 192.439 180.908 192.439Z"
            fill="url(#paint27_radial_5841_7949)"
        />
        <path
            d="M211.951 146.323C216.403 146.323 220.013 141.18 220.013 134.837C220.013 128.493 216.403 123.351 211.951 123.351C207.498 123.351 203.889 128.493 203.889 134.837C203.889 141.18 207.498 146.323 211.951 146.323Z"
            fill="url(#paint28_linear_5841_7949)"
        />
        <path
            d="M262.714 146.323C267.167 146.323 270.776 141.18 270.776 134.837C270.776 128.493 267.167 123.351 262.714 123.351C258.262 123.351 254.652 128.493 254.652 134.837C254.652 141.18 258.262 146.323 262.714 146.323Z"
            fill="url(#paint29_linear_5841_7949)"
        />
        <path
            d="M229.023 146.179C231.464 141.268 237.776 141.906 242.484 143.461C244.424 144.101 245.131 146.35 244.034 148.075C242.883 149.882 241.291 152.161 239.493 154.101C237.759 155.973 235.828 157.596 234.321 158.757C232.858 159.884 230.766 159.593 229.829 158.002C228.086 155.045 226.725 150.805 229.023 146.179Z"
            fill="#FAA83F"
        />
        <defs>
            <linearGradient
                id="paint0_linear_5841_7949"
                x1={171.823}
                y1={292.286}
                x2={536.983}
                y2={292.286}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#AAF3FC" />
                <stop offset={1} stopColor="#68EBFC" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_5841_7949"
                x1={359.756}
                y1={276.362}
                x2={517.776}
                y2={276.362}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#63E657" />
                <stop offset={1} stopColor="#30C222" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_5841_7949"
                x1={215.487}
                y1={312.275}
                x2={275.156}
                y2={400.419}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#63E757" />
                <stop offset={1} stopColor="#2BBF1D" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_5841_7949"
                x1={110.762}
                y1={221.912}
                x2={180.914}
                y2={221.912}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FFD56A" />
                <stop offset={1} stopColor="#FFC418" />
            </linearGradient>
            <linearGradient
                id="paint4_linear_5841_7949"
                x1={390.854}
                y1={159.357}
                x2={449.422}
                y2={159.357}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FFD56A" />
                <stop offset={1} stopColor="#FFC418" />
            </linearGradient>
            <linearGradient
                id="paint5_linear_5841_7949"
                x1={134.684}
                y1={151.932}
                x2={406.994}
                y2={151.932}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FFD56A" />
                <stop offset={1} stopColor="#FFC418" />
            </linearGradient>
            <linearGradient
                id="paint6_linear_5841_7949"
                x1={324.434}
                y1={194.88}
                x2={411.693}
                y2={194.88}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#131920" />
                <stop offset={1} stopColor="#36393D" />
            </linearGradient>
            <linearGradient
                id="paint7_linear_5841_7949"
                x1={294.949}
                y1={158.735}
                x2={387.561}
                y2={157.067}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#131920" />
                <stop offset={1} stopColor="#36393D" />
            </linearGradient>
            <linearGradient
                id="paint8_linear_5841_7949"
                x1={272.448}
                y1={31.5394}
                x2={301.681}
                y2={31.5394}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#6F6E72" />
                <stop offset={1} stopColor="#4E4C4A" />
            </linearGradient>
            <linearGradient
                id="paint9_linear_5841_7949"
                x1={183.813}
                y1={36.8629}
                x2={212.436}
                y2={36.8629}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#6F6E72" />
                <stop offset={1} stopColor="#4E4C4A" />
            </linearGradient>
            <linearGradient
                id="paint10_linear_5841_7949"
                x1={299.988}
                y1={7.66871}
                x2={315.062}
                y2={7.66871}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#6F6E72" />
                <stop offset={1} stopColor="#4E4C4A" />
            </linearGradient>
            <linearGradient
                id="paint11_linear_5841_7949"
                x1={173.361}
                y1={15.471}
                x2={188.469}
                y2={15.471}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#6F6E72" />
                <stop offset={1} stopColor="#4E4C4A" />
            </linearGradient>
            <linearGradient
                id="paint12_linear_5841_7949"
                x1={99.8018}
                y1={75.5905}
                x2={113.622}
                y2={75.5905}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F48186" />
                <stop offset={1} stopColor="#F15B62" />
            </linearGradient>
            <linearGradient
                id="paint13_linear_5841_7949"
                x1={90.6393}
                y1={52.6899}
                x2={90.6393}
                y2={56.9198}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F48186" />
                <stop offset={1} stopColor="#F15B62" />
            </linearGradient>
            <linearGradient
                id="paint14_linear_5841_7949"
                x1={76.0169}
                y1={52.6556}
                x2={76.0169}
                y2={56.8854}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F48186" />
                <stop offset={1} stopColor="#F15B62" />
            </linearGradient>
            <linearGradient
                id="paint15_linear_5841_7949"
                x1={81.25}
                y1={47.3589}
                x2={85.3826}
                y2={47.3589}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F48186" />
                <stop offset={1} stopColor="#F15B62" />
            </linearGradient>
            <linearGradient
                id="paint16_linear_5841_7949"
                x1={81.25}
                y1={62.2424}
                x2={85.3826}
                y2={62.2424}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F48186" />
                <stop offset={1} stopColor="#F15B62" />
            </linearGradient>
            <linearGradient
                id="paint17_linear_5841_7949"
                x1={94.2245}
                y1={189.903}
                x2={105.742}
                y2={189.903}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#D1CDD1" />
                <stop offset={1} stopColor="#BFB8B2" />
            </linearGradient>
            <linearGradient
                id="paint18_linear_5841_7949"
                x1={29.3339}
                y1={-86.5491}
                x2={40.8509}
                y2={-86.5491}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#D1CDD1" />
                <stop offset={1} stopColor="#BFB8B2" />
            </linearGradient>
            <linearGradient
                id="paint19_linear_5841_7949"
                x1={32.755}
                y1={140.374}
                x2={134.715}
                y2={140.374}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#6F6E72" />
                <stop offset={1} stopColor="#4E4C4A" />
            </linearGradient>
            <linearGradient
                id="paint20_linear_5841_7949"
                x1={30.4863}
                y1={229.826}
                x2={120.296}
                y2={350.613}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#62E456" />
                <stop offset={1} stopColor="#2DBE1F" />
            </linearGradient>
            <linearGradient
                id="paint21_linear_5841_7949"
                x1={95.4603}
                y1={350.495}
                x2={117.444}
                y2={350.495}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#6F6E72" />
                <stop offset={1} stopColor="#4E4C4A" />
            </linearGradient>
            <linearGradient
                id="paint22_linear_5841_7949"
                x1={13.4951}
                y1={350.495}
                x2={35.4791}
                y2={350.495}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#6F6E72" />
                <stop offset={1} stopColor="#4E4C4A" />
            </linearGradient>
            <linearGradient
                id="paint23_linear_5841_7949"
                x1={27.5708}
                y1={286.874}
                x2={45.1173}
                y2={286.874}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#63BB62" />
                <stop offset={0.52} stopColor="#00AE51" />
                <stop offset={1} stopColor="#009F47" />
            </linearGradient>
            <linearGradient
                id="paint24_linear_5841_7949"
                x1={59.8527}
                y1={243.435}
                x2={77.3842}
                y2={246.775}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#63BB62" />
                <stop offset={0.52} stopColor="#00AE51" />
                <stop offset={1} stopColor="#009F47" />
            </linearGradient>
            <linearGradient
                id="paint25_linear_5841_7949"
                x1={92.0822}
                y1={243.435}
                x2={109.614}
                y2={246.775}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#63BB62" />
                <stop offset={0.52} stopColor="#00AE51" />
                <stop offset={1} stopColor="#009F47" />
            </linearGradient>
            <radialGradient
                id="paint26_radial_5841_7949"
                cx={0}
                cy={0}
                r={1}
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(295.313 159.357) scale(32.5864 33.082)"
            >
                <stop stopColor="#FAA83F" />
                <stop offset={0.94} stopColor="#FFC92E" />
            </radialGradient>
            <radialGradient
                id="paint27_radial_5841_7949"
                cx={0}
                cy={0}
                r={1}
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(180.908 159.357) rotate(90) scale(33.082 32.5864)"
            >
                <stop stopColor="#FAA83F" />
                <stop offset={0.94} stopColor="#FFD364" />
            </radialGradient>
            <linearGradient
                id="paint28_linear_5841_7949"
                x1={203.855}
                y1={134.837}
                x2={220.013}
                y2={134.837}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#131920" />
                <stop offset={1} stopColor="#36393D" />
            </linearGradient>
            <linearGradient
                id="paint29_linear_5841_7949"
                x1={254.652}
                y1={134.837}
                x2={270.81}
                y2={134.837}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#131920" />
                <stop offset={1} stopColor="#36393D" />
            </linearGradient>
        </defs>
    </svg>
);
export default CarrierBee;
